var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_33246_2104)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_33246_2104)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.1236 113.158L49.9347 111.317C47.8443 110.11 45.4723 109.474 43.0588 109.474L39.3765 109.474C34.4632 109.474 29.9228 106.853 27.4665 102.598L25.6248 99.4089C24.4177 97.3185 22.6815 95.5824 20.5912 94.3747L17.4022 92.5342C13.1475 90.0772 10.5263 85.5375 10.5263 80.6241L10.5263 76.9419C10.5263 74.5271 9.8905 72.1558 8.68342 70.0654L6.84231 66.8765C4.38592 62.6212 4.38592 57.3788 6.84231 53.1236L8.68341 49.9353C9.8905 47.8442 10.5263 45.4728 10.5263 43.0587L10.5263 39.3764C10.5263 34.463 13.1475 29.9227 17.4022 27.4664L20.5912 25.6252C22.6815 24.4182 24.4177 22.6821 25.6247 20.5911L27.4664 17.4028C29.9228 13.1475 34.4632 10.5262 39.3765 10.5262L43.0588 10.5262C45.4723 10.5262 47.8443 9.89044 49.9347 8.68395L53.1236 6.84278C57.3787 4.38575 62.6214 4.38575 66.8763 6.84278L70.0654 8.68395C72.156 9.89044 74.5276 10.5262 76.9415 10.5262L80.6235 10.5262C85.5369 10.5262 90.077 13.1475 92.5338 17.4028L94.3749 20.5911C95.5819 22.6821 97.3179 24.4182 99.4086 25.6252L102.598 27.4664C106.853 29.9227 109.474 34.463 109.474 39.3764L109.474 43.0587C109.474 45.4728 110.109 47.8442 111.316 49.9352L113.157 53.1236C115.614 57.3788 115.614 62.6212 113.157 66.8764L111.316 70.0654C110.109 72.1558 109.474 74.5271 109.474 76.9419L109.474 80.6241C109.474 85.5375 106.853 90.0772 102.598 92.5342L99.4086 94.3747C97.3179 95.5824 95.5819 97.3185 94.3749 99.4089L92.5338 102.598C90.077 106.853 85.5369 109.474 80.6236 109.474L76.9415 109.474C74.5276 109.474 72.156 110.11 70.0654 111.317L66.8763 113.158C62.6214 115.614 57.3787 115.614 53.1236 113.158Z",
  fill: "url(#paint0_linear_33246_2104)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 60.0006,
  cy: 59.9996,
  r: 35.2857,
  stroke: "url(#paint1_linear_33246_2104)",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_33246_2104)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81.7544 53.066C79.4718 53.066 77.4711 54.3568 76.3807 56.2795C76.3738 56.2795 76.371 56.2795 76.371 56.2795C76.371 56.2795 74.6412 59.219 71.6876 63.6196C71.6876 63.6196 74.5023 55.9463 78.105 50.8707C78.105 50.8707 77.4752 49.4515 75.8953 49C75.8953 49 69.9783 54.8732 65.6909 62.532C65.6909 62.532 67.1361 58.4488 70.7346 52.9506C70.7346 52.9506 70.0897 51.5385 68.5221 51.0726C68.5221 51.0726 65.0804 54.3309 60.7764 60.833C60.7764 60.833 62.3096 57.7391 63.9363 54.9987C63.9363 54.9987 63.1209 53.464 61.7128 53.1164C61.7128 53.1164 60.8273 54.1347 59.1813 57.7319C59.1813 57.7319 55.998 62.2205 53.626 64.8859C53.626 64.8859 54.2599 61.1935 59.1456 53.0631C59.1456 53.0631 58.5474 51.6784 56.9221 51.1924C56.9221 51.1924 52.4105 56.6228 48.0103 63.4825C48.0103 63.4825 50.2709 57.3209 53.2314 52.5193C53.2314 52.5193 52.3046 50.8866 51.0203 50.6414C51.0203 50.6414 48.1574 54.2746 45.3935 58.4315C44.8586 55.3838 42.3065 53.066 39.2483 53.066C35.8024 53.066 33 56.0069 33 59.6199C33 63.233 35.8024 66.1739 39.2483 66.1739C41.5199 66.1739 43.5124 64.8946 44.6056 62.9892C45.19 62.0488 46.7149 59.5954 47.4657 58.3839C46.1415 61.3926 44.9782 64.4345 43.5138 68.6605C43.5138 68.6605 44.2329 70.136 45.7125 70.5356C45.7125 70.5356 50.8828 61.7488 53.362 59.131C53.362 59.131 52.0516 61.9883 50.8676 65.9359C50.8676 65.9359 51.5249 67.3942 53.0636 67.8225C53.0636 67.8225 54.9172 66.0672 57.479 62.408L55.0052 69.125C55.0052 69.125 55.8344 70.7274 57.1847 71C57.1847 71 62.4113 60.6786 65.8545 56.7439C65.8545 56.7439 63.2859 62.5421 62.6052 65.5984C62.6052 65.5984 63.0549 66.8951 64.8177 67.4821C64.8177 67.4821 69.2853 59.4786 72.6955 55.7328C72.6955 55.7328 69.5411 62.232 68.7573 65.3806C68.7573 65.3806 69.2839 66.7451 70.9533 67.2889C70.9533 67.2889 72.7092 65.173 75.5983 60.7594C76.1125 63.833 78.6757 66.1768 81.7517 66.1768C85.1976 66.1768 88 63.2373 88 59.6228C88.0028 56.0069 85.2004 53.066 81.7544 53.066ZM39.2483 63.6383C37.1362 63.6383 35.4174 61.8368 35.4174 59.6199C35.4174 57.4045 37.1362 55.6016 39.2483 55.6016C41.3604 55.6016 43.0793 57.4045 43.0793 59.6199C43.0793 61.8368 41.3604 63.6383 39.2483 63.6383ZM81.7544 63.6383C79.6423 63.6383 77.9235 61.8368 77.9235 59.6199C77.9235 57.4045 79.6423 55.6016 81.7544 55.6016C83.8665 55.6016 85.5854 57.4045 85.5854 59.6199C85.5854 61.8368 83.8665 63.6383 81.7544 63.6383Z",
  fill: "#FFECBC"
})));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_33246_2104",
  x: 1,
  y: 5,
  width: 118,
  height: 118,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_33246_2104"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_33246_2104",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_33246_2104",
  x: 30,
  y: 46,
  width: 65,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_33246_2104"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_33246_2104",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_33246_2104",
  x1: 10.4705,
  y1: 4.97905,
  x2: 107.716,
  y2: 111.812,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEDD7B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBB3E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_33246_2104",
  x1: 107.257,
  y1: 20.7139,
  x2: 20.7148,
  y2: 99.2853,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB130"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDB8D"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_33246_2104"
}, /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 120,
  fill: "white"
})));

var SvgOnmoCongrat = function SvgOnmoCongrat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnmoCongrat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onmo-congrat.e6ac0577.svg";
export { ForwardRef as ReactComponent };